import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./i18n";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import ParcelPage from "./pages/ParcelPage";
import TrackerPage from "./pages/TrackerPage";
import GminaPage from "./pages/GminaPage";
import ConsultationsPage from "./pages/ConsultationsPage";
import DashboardPage from "./pages/DashboardPage";
import ProPage from "./pages/ProPage";
import WorkspacePage from "./pages/WorkspacePage";
import PortfolioPage from "./pages/PortfolioPage";
import ReportPage from "./pages/ReportPage";
import DueDiligencePage from "./pages/DueDiligencePage";
import ReportPreviewPage from "./pages/ReportPreviewPage";
import ReportPrototypePage from "./pages/ReportPrototypePage";
import AuthPage from "./pages/AuthPage";
import PrivacyPage from "./pages/PrivacyPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import IndexPage from "./pages/IndexPage";
import GminaIndexPage from "./pages/GminaIndexPage";
import PinkDemoPage from "./pages/PinkDemoPage";
import AdminAnalyticsPage from "./pages/AdminAnalyticsPage";
import BusinessReadinessPage from "./pages/BusinessReadinessPage";
import PricingPage from "./pages/PricingPage";
import CheckoutPage from "./pages/CheckoutPage";
import TestPaymentPage from "./pages/TestPaymentPage";
import InstallPage from "./pages/InstallPage";
import EduProgramPage from "./pages/EduProgramPage";
import EduApplyPage from "./pages/EduApplyPage";
import EduInvitePage from "./pages/EduInvitePage";
import EduDashboardPage from "./pages/EduDashboardPage";
import EduReportPage from "./pages/EduReportPage";
import EduLegalPage from "./pages/EduLegalPage";
import AdminEduPage from "./pages/AdminEduPage";
import AdminHealthPage from "./pages/AdminHealthPage";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/dzialka/:id" element={<ParcelPage />} />
              <Route path="/tracker" element={<TrackerPage />} />
              <Route path="/indeks" element={<IndexPage />} />
              <Route path="/indeks/gmina/:slug" element={<GminaIndexPage />} />
              <Route path="/demo/pink" element={<PinkDemoPage />} />
              <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
          <Route path="/admin/business" element={<BusinessReadinessPage />} />
          <Route path="/cennik" element={<PricingPage />} />
          <Route path="/en/pricing" element={<PricingPage />} />
          <Route path="/platnosc/raport/:parcelId" element={<CheckoutPage kind="report" />} />
          <Route path="/platnosc/plan/:planCode" element={<CheckoutPage kind="plan" />} />
          <Route path="/platnosc/test/:checkoutId" element={<TestPaymentPage />} />
              <Route path="/aplikacja" element={<InstallPage />} />
              <Route path="/gmina/:id" element={<GminaPage />} />
              <Route path="/konsultacje" element={<ConsultationsPage />} />
              <Route path="/panel" element={<DashboardPage />} />
              <Route path="/pro" element={<ProPage />} />
              <Route path="/workspace" element={<WorkspacePage />} />
              <Route path="/portfolio/:id" element={<PortfolioPage />} />
              <Route path="/portfolio/:id/dzialka/:ppId/due-diligence" element={<DueDiligencePage />} />
              <Route path="/raport/podglad/:parcelId" element={<ReportPreviewPage />} />
              <Route path="/raport/prototyp" element={<ReportPrototypePage />} />
              <Route path="/raport/:id" element={<ReportPage />} />
              <Route path="/logowanie" element={<AuthPage />} />
              <Route path="/edu" element={<EduProgramPage />} />
              <Route path="/edu/regulamin" element={<EduLegalPage doc="regulamin" />} />
              <Route path="/edu/prywatnosc" element={<EduLegalPage doc="prywatnosc" />} />
              <Route path="/edu/retencja" element={<EduLegalPage doc="retencja" />} />
              <Route path="/edu/zgloszenie" element={<EduApplyPage />} />
              <Route path="/edu/zaproszenie/:token" element={<EduInvitePage />} />
              <Route path="/edu/panel" element={<EduDashboardPage />} />
              <Route path="/edu/raport/:id" element={<EduReportPage />} />
              <Route path="/admin/edu" element={<AdminEduPage />} />
              <Route path="/admin/health" element={<AdminHealthPage />} />
              <Route path="/prywatnosc" element={<PrivacyPage />} />
              <Route path="/weryfikacja" element={<VerifyEmailPage />} />
              <Route path="/reset" element={<ResetPasswordPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
      </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
